var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src.length)?_c('img',{style:({ fontSize: _vm.size }),attrs:{"alt":_vm.name,"src":_vm.src}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }